"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _gatsby = require("gatsby");

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _ModalRoutingContext = _interopRequireDefault(require("./ModalRoutingContext"));

var withoutPrefix = function withoutPrefix(path) {
  var prefix = typeof __BASE_PATH__ !== "undefined" ? __BASE_PATH__ : __PATH_PREFIX__;
  return path.slice(prefix ? prefix.length : 0);
}; // Creates the page element using the appropriate component type/props based on whether
// we're in "modal mode" or not


var buildPageElement = function buildPageElement(isModal, prevProps, pageResources, props) {
  var _ref = isModal ? prevProps.pageResources : pageResources,
      component = _ref.component,
      page = _ref.page;

  var pageElementProps = (0, _extends2["default"])({}, isModal ? prevProps : props, {
    key: page.path
  });
  return /*#__PURE__*/_react["default"].createElement(component, pageElementProps);
};

var buildModalElement = function buildModalElement(isModal, lastModalProps, pageResources, props) {
  if (!isModal && !lastModalProps) return null; // isModal = rendering the current page as a modal (create an element with the page contents)
  // !isModal = not rendering as a modal, but we may be in the process of animating  the old
  // modal content to close, so render the last modal content we have cached

  var _ref2 = isModal ? pageResources : (0, _get2["default"])(lastModalProps, 'pageResources'),
      component = _ref2.component;

  var modalElementProps = isModal ? props : lastModalProps;

  var _ref3 = isModal ? pageResources.page : (0, _get2["default"])(lastModalProps, 'pageResources.page'),
      path = _ref3.path;

  return /*#__PURE__*/_react["default"].createElement(component, (0, _extends2["default"])({}, modalElementProps, {
    key: path
  }));
};

var ReplaceComponentRenderer = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ReplaceComponentRenderer, _React$Component);

  function ReplaceComponentRenderer(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      prevProps: null,
      lastModalProps: null,
      props: null,
      pathname: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "modalContentRef", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRequestClose", function () {
      var state = {
        noScroll: true
      };
      (0, _gatsby.navigate)(_this.getPreviousPathWithoutPrefix(), {
        state: state
      });
    });
    if (!props.modalComponentPath) _this.state.ModalComponent = _reactModal["default"];
    return _this;
  }

  ReplaceComponentRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(newProps, state) {
    var _ref4;

    // TODO: handle history changes
    // Only update the (old) props in state if the location changed
    if (newProps.location.pathname === state.pathname) return null;
    var oldProps = state.props;
    var oldPageWasModal = (0, _get2["default"])(state, 'props.location.state.modal');
    return _ref4 = {
      // ...state,
      pathname: newProps.location.pathname,
      props: newProps
    }, _ref4[oldPageWasModal ? 'lastModalProps' : 'prevProps'] = oldProps, _ref4;
  };

  var _proto = ReplaceComponentRenderer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.props.modalComponentPath) return; // Access the component we loaded in gatsby-node.js

    var ModalComponent = require(___MODAL_COMPONENT___)["default"];

    this.setState({
      ModalComponent: ModalComponent
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var oldPath = (0, _get2["default"])(prevProps, 'location.pathname');
    var newPath = (0, _get2["default"])(this.props, 'location.pathname');
    var isModal = (0, _get2["default"])(this.props, 'location.state.modal') && this.modalContentRef;
    if (oldPath === newPath || !isModal) return;
    this.modalContentRef.scrollTop = 0;
  }
  /** Returns the path of the previous page we were on, with the prefix removed */
  ;

  _proto.getPreviousPathWithoutPrefix = function getPreviousPathWithoutPrefix() {
    return withoutPrefix(this.state.prevProps.location.pathname);
  };

  _proto.render = function render() {
    var _this2 = this;

    // render modal if props location has modal
    var _this$props = this.props,
        pageResources = _this$props.pageResources,
        location = _this$props.location,
        modalProps = _this$props.modalProps;
    var _this$state = this.state,
        ModalComponent = _this$state.ModalComponent,
        prevProps = _this$state.prevProps,
        lastModalProps = _this$state.lastModalProps;
    if (!ModalComponent) return null; // we're waiting for the modal component to load

    var isModal = prevProps && (0, _get2["default"])(location, 'state.modal'); // const resources = isModal ? prevProps.pageResources : pageResources
    // the page is the previous path if this is a modal, otherwise it's the current path

    var pageElement = buildPageElement(isModal, prevProps, pageResources, this.props);
    var modalElement = buildModalElement(isModal, lastModalProps, pageResources, this.props);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, pageElement, /*#__PURE__*/_react["default"].createElement(ModalComponent, (0, _extends2["default"])({
      onRequestClose: this.handleRequestClose,
      contentRef: function contentRef(node) {
        return _this2.modalContentRef = node;
      }
    }, modalProps, {
      isOpen: !!isModal
    }), modalElement ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: this.props.location.key
    }, /*#__PURE__*/_react["default"].createElement(_ModalRoutingContext["default"].Provider, {
      value: {
        modal: true,
        closeTo: prevProps ? this.getPreviousPathWithoutPrefix() : '/'
      }
    }, modalElement)) : null));
  };

  return ReplaceComponentRenderer;
}(_react["default"].Component);

var replaceComponentRenderer = function replaceComponentRenderer(_ref5, pluginOptions) {
  var props = _ref5.props;
  var modalComponentPath = pluginOptions.modalComponentPath,
      modalProps = pluginOptions.modalProps;
  var mergedProps = (0, _extends2["default"])({}, props, {
    modalComponentPath: modalComponentPath,
    modalProps: modalProps
  });
  return /*#__PURE__*/_react["default"].createElement(ReplaceComponentRenderer, mergedProps);
};

var _default = replaceComponentRenderer;
exports["default"] = _default;